<template>
  <div class="w-full items-center">
    <div
      :class="accounts.length > 3 ? 'grid-cols-5' : 'grid-cols-4'"
      class="grid gap-6"
      v-if="!$screen.portrait"
    >
      <div
        v-for="(item, key) in accounts"
        :key="key"
        :class="
          active_index == key
            ? 'bg-ontick-steel-100 dark:bg-ontick-steel-500 -translate-y-1 scale-105 shadow-2xl'
            : 'dark:bg-ontick-graphite-500 bg-gray-50'
        "
        @click="$emit('optionSelected', item.account_id), (active_index = key)"
        class="border-ontick-steel-300 dark:border-ontick-graphite-500 w-full transform cursor-pointer rounded-lg border-2 px-3 py-3 transition-all duration-200"
      >
        <div class="flex items-center justify-between">
          <div
            :class="
              item.account_type == 'DEMO'
                ? 'bg-gray-500 text-gray-200'
                : 'bg-ontick-blue-900 text-ontick-blue-500'
            "
            class="my-1 inline-flex items-center rounded-md px-2 py-1 text-xs font-medium xl:text-sm"
          >
            {{ item.account_type == "PRD" ? "PROD" : "DEMO" }}
          </div>
          <div class="h-6 w-6" v-html="itemLogo(item.broker_name)"></div>
        </div>
        <p
          :class="
            active_index == key
              ? 'text-ontick-steel-900 dark:text-gray-200'
              : 'text-ontick-steel-500 dark:text-gray-400'
          "
          class="py-2 text-xl font-medium"
        >
          {{ item.broker_name }} #({{ item.account_number }})
        </p>
        <div class="ml-auto flex items-center justify-end">
          <div
            content="Estratégias em execução"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            <div
              v-show="item.running_investments > 0"
              class="bg-ontick-green-500 absolute mr-3 inline-flex h-3 w-3 animate-ping rounded-full opacity-75"
            ></div>
            <div
              class="h-3 w-3 rounded-full"
              :class="
                item.running_investments == 0
                  ? 'bg-gray-400'
                  : 'bg-ontick-green-500'
              "
            ></div>
          </div>
          <p class="text-ontick-steel-500 pl-2 dark:text-gray-300">
            {{ item.running_investments }}
          </p>
        </div>
      </div>

      <placeholder-card-component v-if="accounts.length == 0" :qtd="1" />

      <div
        @click="active = !active"
        :class="accounts.length == 0 ? 'col-span-3' : ''"
        class="border-ontick-steel-300 dark:border-ontick-carbon-500 dark:bg-ontick-graphite-500 relative flex cursor-pointer items-center justify-center rounded-lg border bg-gray-50 px-6 py-6 text-center"
      >
        <div>
          <div class="flex justify-center">
            <svg
              width="49"
              height="49"
              viewBox="0 0 49 49"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M24.4502 0.0996094C18.085 0.0996094 11.9805 2.62817 7.47963 7.12904C2.97876 11.6299 0.450195 17.7344 0.450195 24.0996C0.450195 30.4648 2.97876 36.5693 7.47963 41.0702C11.9805 45.571 18.085 48.0996 24.4502 48.0996C30.8154 48.0996 36.9199 45.571 41.4208 41.0702C45.9216 36.5693 48.4502 30.4648 48.4502 24.0996C48.4502 17.7344 45.9216 11.6299 41.4208 7.12904C36.9199 2.62817 30.8154 0.0996094 24.4502 0.0996094ZM21.4502 33.0996C21.4502 33.8953 21.7663 34.6583 22.3289 35.2209C22.8915 35.7835 23.6545 36.0996 24.4502 36.0996C25.2458 36.0996 26.0089 35.7835 26.5715 35.2209C27.1341 34.6583 27.4502 33.8953 27.4502 33.0996V27.0996H33.4502C34.2458 27.0996 35.0089 26.7835 35.5715 26.2209C36.1341 25.6583 36.4502 24.8953 36.4502 24.0996C36.4502 23.304 36.1341 22.5409 35.5715 21.9783C35.0089 21.4157 34.2458 21.0996 33.4502 21.0996H27.4502V15.0996C27.4502 14.304 27.1341 13.5409 26.5715 12.9783C26.0089 12.4157 25.2458 12.0996 24.4502 12.0996C23.6545 12.0996 22.8915 12.4157 22.3289 12.9783C21.7663 13.5409 21.4502 14.304 21.4502 15.0996V21.0996H15.4502C14.6545 21.0996 13.8915 21.4157 13.3289 21.9783C12.7663 22.5409 12.4502 23.304 12.4502 24.0996C12.4502 24.8953 12.7663 25.6583 13.3289 26.2209C13.8915 26.7835 14.6545 27.0996 15.4502 27.0996H21.4502V33.0996Z"
                fill="#2D3748"
              />
            </svg>
          </div>
          <span class="trucante">
            <p class="mt-3 text-xs text-gray-500 xl:text-sm">
              Adicionar nova conta
            </p>
          </span>
        </div>
      </div>
    </div>

    <swiper v-if="$screen.portrait" :auto-update="true" :options="options">
      <swiper-slide
        v-for="(item, key) in accounts"
        :key="key"
        :class="
          active_index == key
            ? 'bg-ontick-steel-100 dark:bg-ontick-steel-500 -translate-y-1 scale-105 shadow-2xl'
            : 'dark:bg-ontick-graphite-500 bg-gray-50'
        "
        @click.native="
          $emit('optionSelected', item.account_id), (active_index = key)
        "
        class="border-ontick-steel-300 dark:border-ontick-graphite-500 my-3 w-full transform cursor-pointer rounded-lg border-2 px-3 py-3 transition-all duration-200"
      >
        <div class="flex items-center justify-between">
          <div
            :class="
              item.account_type == 'DEMO'
                ? 'bg-gray-500 text-gray-200'
                : 'bg-ontick-blue-900 text-ontick-blue-500'
            "
            class="my-1 inline-flex items-center rounded-md px-2 py-1 text-xs font-medium xl:text-sm"
          >
            {{ item.account_type == "PRD" ? "PROD" : "DEMO" }}
          </div>
          <div v-html="itemLogo(item.broker_name)"></div>
        </div>
        <p
          :class="
            active_index == key
              ? 'text-ontick-steel-900 dark:text-gray-200'
              : 'text-ontick-steel-500 dark:text-gray-400'
          "
          class="text-made py-2 font-medium md:text-xl"
        >
          {{ item.broker_name }} #({{ item.account_number }})
        </p>
        <div class="ml-auto flex items-center justify-end">
          <div
            content="Estratégias em execução"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            <div
              v-show="item.running_investments > 0"
              class="bg-ontick-green-500 absolute mr-3 inline-flex h-3 w-3 animate-ping rounded-full opacity-75"
            ></div>
            <div
              class="h-3 w-3 rounded-full"
              :class="
                item.running_investments == 0
                  ? 'bg-gray-400'
                  : 'bg-ontick-green-500'
              "
            ></div>
          </div>
          <p class="text-ontick-steel-600 pl-2 dark:text-gray-300">
            {{ item.running_investments }}
          </p>
        </div>
      </swiper-slide>

      <swiper-slide
        @click="active = !active"
        class="bg-ontick-steel-100 dark:bg-ontick-graphite-500 relative my-3 flex cursor-pointer flex-col items-center justify-center rounded-lg p-3 text-center md:p-6"
      >
        <div class="flex justify-center">
          <svg
            width="49"
            height="49"
            viewBox="0 0 49 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.4502 0.0996094C18.085 0.0996094 11.9805 2.62817 7.47963 7.12904C2.97876 11.6299 0.450195 17.7344 0.450195 24.0996C0.450195 30.4648 2.97876 36.5693 7.47963 41.0702C11.9805 45.571 18.085 48.0996 24.4502 48.0996C30.8154 48.0996 36.9199 45.571 41.4208 41.0702C45.9216 36.5693 48.4502 30.4648 48.4502 24.0996C48.4502 17.7344 45.9216 11.6299 41.4208 7.12904C36.9199 2.62817 30.8154 0.0996094 24.4502 0.0996094ZM21.4502 33.0996C21.4502 33.8953 21.7663 34.6583 22.3289 35.2209C22.8915 35.7835 23.6545 36.0996 24.4502 36.0996C25.2458 36.0996 26.0089 35.7835 26.5715 35.2209C27.1341 34.6583 27.4502 33.8953 27.4502 33.0996V27.0996H33.4502C34.2458 27.0996 35.0089 26.7835 35.5715 26.2209C36.1341 25.6583 36.4502 24.8953 36.4502 24.0996C36.4502 23.304 36.1341 22.5409 35.5715 21.9783C35.0089 21.4157 34.2458 21.0996 33.4502 21.0996H27.4502V15.0996C27.4502 14.304 27.1341 13.5409 26.5715 12.9783C26.0089 12.4157 25.2458 12.0996 24.4502 12.0996C23.6545 12.0996 22.8915 12.4157 22.3289 12.9783C21.7663 13.5409 21.4502 14.304 21.4502 15.0996V21.0996H15.4502C14.6545 21.0996 13.8915 21.4157 13.3289 21.9783C12.7663 22.5409 12.4502 23.304 12.4502 24.0996C12.4502 24.8953 12.7663 25.6583 13.3289 26.2209C13.8915 26.7835 14.6545 27.0996 15.4502 27.0996H21.4502V33.0996Z"
              fill="#2D3748"
            />
          </svg>
        </div>
        <span>
          <p class="mt-3 text-xs text-gray-500 xl:text-sm">
            Adicionar nova conta
          </p>
        </span>
      </swiper-slide>
    </swiper>

    <modal-account @close="active = false" v-if="active" :active="active" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import ModalAccount from "@/app/shared/components/modal-account/modal.component";
import PlaceholderCardComponent from "../../../shared/components/placeholder/placeholder-card.component.vue";

export default {
  components: {
    ModalAccount,
    PlaceholderCardComponent,
    Swiper,
    SwiperSlide,
  },

  props: {
    accounts: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      active: false,
      active_index: 0,
      options: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },

  computed: {
    ...mapState({
      accountTypes: (state) => state.accountTypes,
    }),
  },

  methods: {
    ...mapActions({
      updateAccount: "accountTypes/updateAccount",
    }),

    itemLogo(value) {
      let img;
      if (value == "OnTick") {
        img = this.$icons.ontick;
      } else if (value == "XP") {
        img = this.$icons.xp;
      } else if (value == "Cripto") {
        img = this.$icons.bitcoin;
      }
      return img;
    },

    optionSelected(item) {
      let account = item.account_type == "PRD" ? "PRODUÇÃO" : "DEMO";

      var ehEditInvestment = false;
      if (this.$route.path.split("/").length == 4) {
        var path = this.$route.path.split("/");
        if (path[1] == "investments" && path[3] == "edit") {
          ehEditInvestment = true;
        }
      }
      if (!ehEditInvestment) {
        // Caso não esteja em editar parâmetros, deve atualizar a conta normalmente.
        this.toggleSelect = false;
        let params = { account: item, router: this.$route.path };

        if (
          this.accountTypes.selectedAccount.account_type != item.account_type
        ) {
          this.$swal({
            titleText: `Alterado para ${account} ${item.broker_name} `,
            icon: "success",
            icon: "success",
            iconHtml: this.$icons.swal_success,
            // toast: true,
            position: "top-end",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,

            customClass: {
              popup: "content",
              title: "title",
              confirmButton: "sweetalert_confirm_button",
              content: "content",
              backdrop: "swal2-backdrop-hide",
            },
          });
        }

        // this.accountTypes.selectedAccount

        this.updateAccount(params);
      } else {
        this.toggleSelect = false;
        this.tempParams = { account: item, router: this.$route.path };
        // Não é pra  alterar a conta, apenas mandar o evento.
        EventBus.$emit("CHANGE_ACCOUNT");
      }
    },
  },
};
</script>
<style lang="scss"></style>
